import { DesignToken } from "./design-token";
import { WhiteLabelingSetting } from "./white-labeling-settings";

export class DesignTokenAdapter {
  private readonly designTokenMap: Partial<Record<WhiteLabelingSetting, DesignToken>> = {
    [WhiteLabelingSetting.MenuBackgroundColor]: DesignToken.MenuBackgroundRGB,
    [WhiteLabelingSetting.MenuTextColor]: DesignToken.MenuTextRGB,
    [WhiteLabelingSetting.MenuUnderlineColor]: DesignToken.AccentRGB,
    [WhiteLabelingSetting.FontFamily]: DesignToken.FontFamily,
    [WhiteLabelingSetting.HeadingTextColor]: DesignToken.HeadingTextRGB,
    [WhiteLabelingSetting.ButtonBackgroundColor]: DesignToken.ButtonRGB,
    [WhiteLabelingSetting.ButtonTextColor]: DesignToken.ButtonTextRGB,
    [WhiteLabelingSetting.AppBackgroundColor]: DesignToken.AppBackgroundRGB,
    [WhiteLabelingSetting.HyperlinkColor]: DesignToken.HyperlinkRGB,
    [WhiteLabelingSetting.MainClickableColor]: DesignToken.PrimaryMainRGB,
    [WhiteLabelingSetting.ChartColor1]: DesignToken.ChartRGB1,
    [WhiteLabelingSetting.ChartColor2]: DesignToken.ChartRGB2,
    [WhiteLabelingSetting.ChartColor3]: DesignToken.ChartRGB3,
    [WhiteLabelingSetting.PieChartColor1]: DesignToken.PieChartRGB1,
    [WhiteLabelingSetting.PieChartColor2]: DesignToken.PieChartRGB2,
    [WhiteLabelingSetting.PieChartColor3]: DesignToken.PieChartRGB3,
    [WhiteLabelingSetting.PieChartColor4]: DesignToken.PieChartRGB4,
    [WhiteLabelingSetting.PieChartColor5]: DesignToken.PieChartRGB5,
    [WhiteLabelingSetting.PieChartColor6]: DesignToken.PieChartRGB6,
  };

  public toDesignToken(key: WhiteLabelingSetting): DesignToken | undefined {
    return this.designTokenMap[key];
  }
}
